import {Injectable} from '@angular/core';
import {ApiServiceService} from '../api-service.service';
import {HttpClient} from '@angular/common/http';
import {AdvanceEmiPlan} from "../model/AdvanceEmiPlan";

@Injectable()
export class AdvanceEmiPlanService {
    constructor(private http: HttpClient, private apiServiceService: ApiServiceService) {
    }

    async create(advanceEmiPlan: AdvanceEmiPlan): Promise<AdvanceEmiPlan> {
        const baseUrl = this.apiServiceService.baseURL();
        return AdvanceEmiPlan.from(await this.http.post(baseUrl + 'advance-emi-plan', advanceEmiPlan).toPromise());
    }
}
